import { c as _c } from "react/compiler-runtime";
import type { LiveOrderBy } from '@module/apis/client-side/live/type';
import { useFetchLiveInfiniteQuery } from '@module/queries/live/liveQueryHooks';
import { useIntersectionObserver } from '@module/utils/useIntersectionObserver';
import TimeConstants from '../../utils/item';
const LIVE_LIST_CACHE_TIME = TimeConstants.ONE_MINUTE * 3;
interface Props {
  onlyNewBj: 'Y' | 'N';
  orderBy: LiveOrderBy;
  limit?: number;
  refetchInterval?: number | false;
}
const useLiveViewModel = t0 => {
  const $ = _c(27);
  const {
    onlyNewBj,
    orderBy,
    limit: t1,
    refetchInterval: t2
  } = t0;
  const limit = t1 === undefined ? 24 : t1;
  const refetchInterval = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== limit || $[1] !== onlyNewBj || $[2] !== orderBy) {
    t3 = {
      orderBy,
      onlyNewBj,
      limit
    };
    $[0] = limit;
    $[1] = onlyNewBj;
    $[2] = orderBy;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== refetchInterval) {
    t4 = {
      staleTime: LIVE_LIST_CACHE_TIME,
      gcTime: LIVE_LIST_CACHE_TIME,
      refetchInterval
    };
    $[4] = refetchInterval;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const {
    data,
    isLoading,
    isFetching,
    hasNextPage,
    fetchNextPage,
    refetch,
    hasPreviousPage,
    fetchPreviousPage
  } = useFetchLiveInfiniteQuery(t3, t4);
  let t5;
  if ($[6] !== hasNextPage) {
    t5 = () => hasNextPage;
    $[6] = hasNextPage;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== fetchNextPage || $[9] !== t5) {
    t6 = {
      isReadyToFetch: t5,
      onInView: fetchNextPage
    };
    $[8] = fetchNextPage;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const {
    observerRef
  } = useIntersectionObserver(t6);
  let t7;
  if ($[11] !== hasPreviousPage) {
    t7 = () => hasPreviousPage;
    $[11] = hasPreviousPage;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== fetchPreviousPage) {
    t8 = () => {
      const mainContents = document.getElementById("main-contents");
      if (mainContents) {
        mainContents.scrollBy({
          top: 500
        });
      }
      fetchPreviousPage();
    };
    $[13] = fetchPreviousPage;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = {
      isReadyToFetch: t7,
      onInView: t8
    };
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const {
    observerRef: topObserverRef
  } = useIntersectionObserver(t9);
  let t10;
  if ($[18] !== data || $[19] !== fetchNextPage || $[20] !== hasNextPage || $[21] !== isFetching || $[22] !== isLoading || $[23] !== observerRef || $[24] !== refetch || $[25] !== topObserverRef) {
    t10 = {
      data,
      isLoading,
      isFetching,
      observerRef,
      refetch,
      topObserverRef,
      fetchNextPage,
      hasNextPage
    };
    $[18] = data;
    $[19] = fetchNextPage;
    $[20] = hasNextPage;
    $[21] = isFetching;
    $[22] = isLoading;
    $[23] = observerRef;
    $[24] = refetch;
    $[25] = topObserverRef;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
};
export default useLiveViewModel;